import { Button } from '@atoms/Button';
import { formatCurrency } from '@utils/formatters';
import type { CartItem } from '@/types';

interface CartItemRowProps {
  item: CartItem;
  onUpdate: (quantity: number) => void;
  onRemove: () => void;
  disabled?: boolean;
}

export function CartItemRow({ item, onUpdate, onRemove, disabled }: CartItemRowProps) {
  return (
    <div className="flex items-center gap-3 border-b border-gray-100 py-3 last:border-0">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-lg">
        {item.image ? (
          <img src={item.image} alt="" className="h-full w-full rounded-lg object-cover" />
        ) : (
          '📦'
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium text-gray-900">{item.productName}</p>
        <p className="text-sm text-brand-600">{formatCurrency(item.unitPrice)}</p>
      </div>
      <div className="flex items-center gap-1">
        <Button
          size="sm"
          variant="outline"
          disabled={disabled}
          onClick={() => onUpdate(item.quantity - 1)}
        >
          −
        </Button>
        <span className="w-8 text-center text-sm font-medium">{item.quantity}</span>
        <Button
          size="sm"
          variant="outline"
          disabled={disabled}
          onClick={() => onUpdate(item.quantity + 1)}
        >
          +
        </Button>
      </div>
      <Button size="sm" variant="ghost" disabled={disabled} onClick={onRemove}>
        ✕
      </Button>
    </div>
  );
}
